'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { scrollToTop } from './utils';

export default function Template({ children }: { children: React.ReactNode }) {
  // keep using display: 'none' for the header and footer on welcome and checkout pages, because we need to leverage the adobe script from footer for these two pages.
  const notShowHeaderFooterPages = ['/apac/welcome'];
  const notShowHeaderPages = ['/apac/checkout', ...notShowHeaderFooterPages];

  const notShowFooterPages = notShowHeaderFooterPages;

  const pathname = usePathname();

  useEffect(() => {
    scrollToTop();

    if (notShowHeaderPages.some((page) => page.includes(pathname))) {
      if (document.getElementById('header5')) {
        document.getElementById('header5').style.display = 'none';
      }

      document.querySelector('body').style.marginTop = '0px';
    } else {
      if (document.getElementById('header5')) {
        document.getElementById('header5').style.display = '';
      }
      document.querySelector('body').style.marginTop = '';
    }
    if (notShowFooterPages.some((page) => page.includes(pathname))) {
      if (document.getElementById('footer5')) {
        document.getElementById('footer5').style.display = 'none';
      }
    } else {
      if (document.getElementById('footer5')) {
        document.getElementById('footer5').style.display = '';
      }
    }
  }, [pathname]);

  return children;
}
